import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/get/staffAndKpi',
      data
    });
  },
  add(data) {
    return http.post({
      url: '/la/admin/add/staffKpi',
      data,
      dataType: 'form'
    });
  },
  seachHis(data) {
    return http.get({
      url: '/la/admin/get/historyStaffKpiByUserId',
      data
    });
  }
};
